import React, { useState, useMemo, useEffect } from "react";
import "../rfq/RfqList.scss";
import { NotFound } from "../../components/common/NotFound";
import DeleteModal from "../../components/common/DeleteModal";
import TableGrid from "../../components/common/TableGrid";
import { useSearch } from "../../hooks/useSearch";
import Data from "../../data/data.json";
import { Pagination } from "../../components/common/Pagination";
import Avatar from "../../components/common/Avatar";
import Chip from "../../components/common/Chip";
import filterrSvg from "../.././assets/images/funnel.svg";

const RfqList = () => {
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(10);

  const [data] = useState(Data);
  const { filteredResults } = useSearch(data, search);

  const pageSize = count;
  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return data?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, data, count]);

  const [baseColumns] = useState([
    {
      heading: "RFQID",
      value: "RFQID",
      sortable: true,
      title: "RFQID",
      dataIndex: "RFQID",
      key: "RFQID",
    },
    {
      heading: "Customer Name",
      value: "CustomerName",
      sortable: true,
      title: "CustomerName",
      dataIndex: "CustomerName",
      key: "CustomerName",
    },

    {
      heading: "Project Name",
      value: "ProjectName",
      sortable: true,
      title: "ProjectName",
      dataIndex: "ProjectName",
      key: "ProjectName",
    },
    {
      heading: "Company Name",
      value: "CompanyName",
      sortable: true,
      title: "CompanyName",
      dataIndex: "CompanyName",
      key: "CompanyName",
    },
    {
      heading: "Country",
      value: "Country",
      sortable: true,
      title: "Country",
      dataIndex: "Country",
      key: "Country",
    },
    {
      heading: "Due Date",
      value: "DueDate",
      sortable: true,
      title: "DueDate",
      dataIndex: "DueDate",
      key: "DueDate",
    },
  ]);

  const [selected, setSelected] = useState([]);

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData == true) {
      setSelected((oldData) => [...oldData, e.target.value]);
      // let value = baseColumns.filter((item) => !selected.includes(item.dataIndex))
      // setFilterColumn(value);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };

  const [filterColumn, setFilterColumn] = useState([]);

  useEffect(() => {
    let value = baseColumns.filter(({ title }) => !selected.includes(title));
    setFilterColumn(value);
  }, [selected]);
  return (
    <>
      <section id="rfqList">
        <div className="container-fluid">
          <div className="row pt-1">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="card">
                <div className="card-body">
                  <div className="row search-area-row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto">
                      <div>
                        <h6>RFQ</h6>
                        <p>100 Results Found</p>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto">
                      <div className="d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-sm-start">
                        <div className="input-group text-align">
                          <div className="input-group-append">
                            <button className="btn" type="button">
                              <i className="fas fa-times"></i>
                            </button>
                            <button className="btn" type="button">
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                        <div className="text-align">
                          <button
                            className="btn filter-btn"
                            type="button"
                            data-toggle="modal"
                            data-target="#filterRightSideModalPopup"
                          >
                            <span>
                              <img src={filterrSvg}></img>
                            </span>
                          </button>
                        </div>
                        <div className="text-align">
                          <button className="btn refresh-btn" type="button">
                            <i class="fas fa-redo"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- search-area-sec ends --> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row table-row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="card mt-1">
                <div className="card-body">
                  <div className="header d-flex justify-content-between align-items-center flex-wrap mb-1">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <Avatar />
                      <h4>LuminaCraft Technology Solutions</h4>
                      <Chip />
                    </div>
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div class="dropdown dropleft text-align">
                        <i
                          class="fas fa-ellipsis-v"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="false"
                          aria-expanded="false"
                        ></i>
                        <div
                          class="dropdown-menu p-0"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <ul>
                            <li>
                              <span>
                                <i class="fas fa-sync mr-1"></i>Convert to Quote
                              </span>
                            </li>
                            <li>
                              <span>
                                <i class="fas fa-trash-alt mr-1"></i>Delete
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="content mb-3">
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>RFQ Ref</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Contact Person</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Phone Number</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Company Information</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Created On</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Due Date</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Country</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-1">
                <div className="card-body">
                  <div className="header d-flex justify-content-between align-items-center flex-wrap mb-1">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <Avatar />
                      <h4>LuminaCraft Technology Solutions</h4>
                      <Chip />
                    </div>
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div class="dropdown dropleft text-align">
                        <i
                          class="fas fa-ellipsis-v"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="false"
                          aria-expanded="false"
                        ></i>
                        <div
                          class="dropdown-menu p-0"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <ul>
                            <li>
                              <span>
                                <i class="fas fa-print mr-1"></i> Print
                              </span>
                            </li>
                            <li>
                              <span>
                                <i class="fas fa-share-square mr-1"></i>Export
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="content mb-3">
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>RFQ Ref</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Contact Person</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Phone Number</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Company Information</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Created On</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Due Date</label>
                    </div>
                    <div className="flex-column">
                      <h5>ORD-789-JK95</h5>
                      <label>Country</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- deleteModal --> */}
          <DeleteModal />

          {/*  <!-- NotFound --> */}
          <NotFound />
        </div>
      </section>
      <div className="container-fluid delivery-note-list-sec d-none">
        {/* <!-- search-area-sec starts --> */}
        <div className="card mt-3">
          <div className="card-body">
            <section className="search-area-sec">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12">
                  <div className="mob-text-align">
                    <p>
                      RFQ -{" "}
                      <span>
                        {" "}
                        {currentTableData.length > 0
                          ? search.length > 0
                            ? filteredResults?.length
                            : currentTableData.length
                          : currentTableData.length}{" "}
                        Results Found
                      </span>
                    </p>
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <div className="input-group text-align">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn"
                        type="button"
                        onClick={(e) => setSearch("")}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                      <button className="btn" type="button">
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-2 col-sm-12 col-xs-12">
                  <div class="dropdown text-align mob-mt-13">
                    <button
                      className="btn hambeger-btn"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-bars"></i>
                    </button>

                    <div
                      class="dropdown-menu p-3"
                      aria-labelledby="dropdownMenuButton"
                    >
                      {baseColumns.map((data, index) => (
                        <div class="custom-control custom-switch pb-2 ">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id={`${index}`}
                            value={data.title}
                            onChange={(e) => handleChange(e, index)}
                          />
                          <label class="custom-control-label" for={`${index}`}>
                            {data.title}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-2 col-sm-12 col-xs-12">
                  <div className="text-align mob-mt-13">
                    <button
                      className="btn filter-btn"
                      type="button"
                      data-toggle="modal"
                      data-target="#filterRightSideModalPopup"
                    >
                      <span className="float-left">
                        <i className="fas fa-filter"></i>
                      </span>
                      <span className="float-right mt-1">Filter</span>
                    </button>
                  </div>
                </div>
              </div>
            </section>
            {/* <!-- search-area-sec ends --> */}
            {/* <!-- table-sec starts --> */}

            {currentTableData.length > 0 ? (
              <section className="table-sec mt-3">
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <table className="table table-striped table-borderless">
                        {search.length > 1 ? (
                          filteredResults?.length > 0 ? (
                            <TableGrid
                              data={filteredResults}
                              column={filterColumn}
                            />
                          ) : (
                            <NotFound />
                          )
                        ) : (
                          <TableGrid
                            data={currentTableData}
                            column={filterColumn}
                          />
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </section>
            ) : (
              <NotFound />
            )}
            {/* <!-- table-sec ends --> */}

            {/* pagination-sec start */}
            <section className="pagination-sec">
              <div className="row">
                <div className="col-md-12">
                  <div className="pagination-d-flex">
                    <nav aria-label="Page navigation example">
                      <Pagination
                        className="pagination-bar pl-0"
                        currentPage={currentPage}
                        totalCount={data.length}
                        pageSize={pageSize}
                        onPageChange={(page) => setCurrentPage(page)}
                      />
                    </nav>
                    <div className="d-flex justify-content-end ml-4">
                      <p className="mr-2">Show</p>
                      <select
                        className="form-control"
                        value={count}
                        onChange={(e) => setCount(Number(e.target.value))}
                      >
                        {[10, 25, 50].map((Count) => (
                          <option key={Count} value={Count}>
                            {Count}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* pagination-sec end */}
          </div>
        </div>

        {/* <!-- filter modal --> */}

        {/* <!-- deleteModal--> */}
        <DeleteModal />
      </div>
    </>
  );
};
export default RfqList;
